import React from 'react'
import { Card1 } from '../../components/ApplicantProfile/Card1/Card1'
import { Card2 } from '../../components/ApplicantProfile/Card2/Card2'
import { Sidebar } from '../../components/Sidebar/Sidebar'

export const ApplicantProfile = () => {
  // applicant profile
  // card 1 : personal details card
  // card 2 : interview details card
  return (
    <>
      <Sidebar />

      <div className="container">
        <div className="applicantProfile">
          <Card1 />
          <Card2 />
        </div>
      </div>
    </>
  )
}
